import { Controller } from "@hotwired/stimulus"

// Drives a preset date-range picker: a preset <select> whose "custom" option
// reveals an operator (before / after / within) plus single or range inputs.
export default class extends Controller {
  static targets = ["preset", "custom", "operator", "single", "range"]

  connect() {
    this.togglePreset()
  }

  togglePreset() {
    const isCustom = this.presetTarget.value === "custom"
    this.customTarget.classList.toggle("hidden", !isCustom)
    if (isCustom) this.toggleOperator()
  }

  toggleOperator() {
    const isRange = this.operatorTarget.value === "within"
    this.singleTarget.classList.toggle("hidden", isRange)
    this.rangeTarget.classList.toggle("hidden", !isRange)
  }
}
